<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <!-- <video :src="video_url" controls></video> -->
      <slot></slot>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :class="`${arabic ? 'arFont' : 'enFont'}`"
          color="primary"
          @click.native="close"
          >{{ i18n["close"] }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "video_url"],
  methods:{
    close(){
      this.$emit('close')
    }
  },
  computed:{
    language() {
			return this.$store.state.language;
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language];
		},
		arabic() {
			return this.$store.state.language == "ar"
		},
  }
}
</script>